import hours from './hours'

export default
{
    hours
};
